import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

interface LoadingProps {
  inverted?: boolean;
  content?: string;
}

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
//  index that is not overlap the top navigation bar
//   zIndex: theme.zIndex.drawer + 1,
  zIndex: 9999,
  color: '#fff',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

export default function LoadingComponent({ 
  inverted = true, 
  content = 'Loading...' 
}: LoadingProps) {
  return (
    <StyledBackdrop open={true}>
      <CircularProgress 
        color={inverted ? 'inherit' : 'primary'}
        size={60}
        thickness={4}
      />
      <Box mt={2}>
        <Typography 
          variant="h6" 
          color={inverted ? 'white' : 'textPrimary'}
        >
          {content}
        </Typography>
      </Box>
    </StyledBackdrop>
  );
}   